module.exports = __webpack_public_path__ + "static/img/h-i-9.dedcffb5.png";